import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { asapScheduler, fromEvent, map, take, tap } from 'rxjs';
import {
  isLocalStorageKey,
  LOCAL_STORAGE_KEYS_TOKEN,
} from '../models/local-storage-store.models';
import { LocalStorageActions } from '../store/local-storage.actions';
import { LocalStorageManagementFeature } from '../store/local-storage.reducers';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageManagementService {
  private readonly localStorageKeys: string[] = inject(
    LOCAL_STORAGE_KEYS_TOKEN
  );
  private readonly store: Store = inject(Store);

  private readonly changeLocalStorageContentSubscription =
    fromEvent<StorageEvent>(window, 'storage')
      .pipe(
        map(event => {
          if (isLocalStorageKey(this.localStorageKeys)(event.key)) {
            this.store.dispatch(
              LocalStorageActions.refreshLocalStorageByKey({ key: event.key })
            );
          }
        })
      )
      .subscribe();

  private readonly initialLocalStorageContentSubscription = this.store
    .select(LocalStorageManagementFeature.selectLocalStorageManagementState)
    .pipe(
      take(1),
      tap(() =>
        asapScheduler.schedule(() =>
          this.store.dispatch(LocalStorageActions.refreshLocalStorage())
        )
      )
    )
    .subscribe();
}
